import { Spacing, useScopedSelector, TertiarySubmitButton, TertiaryButton, ActionBar as ActionBarCore } from 'ia-react-core';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { MessageDetailsPageState } from '../../../../../../interfaces/MessageDetailsPageState';
import { setModificationMode } from '../../../../MessageDetailsPage.actions';
export interface ActionBarProps {}

const ActionBar: FC<ActionBarProps> = () => {
  const isSubmitting = useScopedSelector((state: MessageDetailsPageState) => state.mailModificationForm?.isSubmitting);
  const { t } = useTranslation('MessageDetailsPage');
  const dispatch = useDispatch();

  const handleAnswerMessage = useCallback(() => {
    dispatch(setModificationMode(false));
  }, [dispatch]);

  return (
    <Spacing m-l={12}>
      <ActionBarCore flexButtonsXs>
        <TertiarySubmitButton busy={isSubmitting}>{t('sendAnswerButton')}</TertiarySubmitButton>
        <TertiaryButton outline disabled={isSubmitting} onClick={handleAnswerMessage}>{t('cancelButton')}</TertiaryButton>
      </ActionBarCore>
    </Spacing>
  );
};
export default ActionBar;
